<template>
  <div class="f360-aviso-padrao" :class="tipoBanner">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
type Props = {
  tipo: "default" | "success" | "warning" | "danger" | "info";
}
import { computed } from 'vue'
const props = withDefaults(defineProps<Props>(), {
  tipo: "default"
});
const tipoBanner = computed(() => {
  switch (props.tipo) {
    case "default":
      return "vc-background--default";
    case "success":
      return "vc-background--success";
    case "warning":
      return "vc-background--warning";
    case "danger":
      return "vc-background--danger";
    case "info":
      return "vc-background--info";
    default:
      return "vc-background--default";
  }
});
</script>

<style lang="scss">
@use "@/styles/theme/f360-theme" as *;
@use "@/styles/variables" as *;

.f360-aviso-padrao {
  font-family: $fontFamily;
  width: auto;
  height: 1.875rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.7rem;
  border-radius: 0.3125rem;
  color: #070707;
  font-weight: 400;
  font-size: 14px;
  line-height: 32px;
  margin: 6px 0 2px 0;

  .sIcon {
    font-size: 14px;
  }

  .content-left {
    display: flex;
    align-items: center;
  }

  .content-right {
    display: flex;
    align-items: center;

    p {
      margin-right: 10px;
    }
  }

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    height: auto;

    .content-left {
      display: flex;
      flex-direction: column;

      p {
        text-align: center;
      }
    }
  }
}
</style>
